import { useMutation, useQueryClient } from '@tanstack/react-query'

import { supabase } from '@/lib/supabase/cliente'
import { mensajeDeError } from '@/lib/supabase/errores'

/**
 * Corregir la zona de una orden desde la programación.
 *
 * Va antes que el ajuste del radio, y no es un detalle de orden: con la zona
 * equivocada, tocar el radio le cambiaría los metros a un barrio que no tiene
 * nada que ver con esta orden.
 */
export function useCambiarZona() {
  const clienteConsultas = useQueryClient()

  return useMutation({
    mutationFn: async (datos: { ordenServicioId: string; zonaId: string }) => {
      const { error } = await supabase.rpc('fn_cambiar_zona_de_la_orden', {
        p_orden_servicio_id: datos.ordenServicioId,
        p_zona_id: datos.zonaId,
      })

      if (error) throw new Error(mensajeDeError(error))
    },
    onSuccess: async () => {
      await Promise.all(
        [
          ['sitio-de-la-orden'],
          ['ordenes-servicio'],
          ['quien-puede'],
          ['mapa-de-calor'],
          ['mis-geocercas'],
        ].map((clave) => clienteConsultas.invalidateQueries({ queryKey: clave })),
      )
    },
  })
}
